import get from 'lodash/get';
import size from 'lodash/size';
import { ValidationOptions, ValidationArguments, registerDecorator } from 'class-validator';

import { ScheduleBlock } from '../OfficeHours';

export const HasNoOverlappingRanges =
  (validationOptions?: ValidationOptions) => (object: Object, propertyName: string) =>
    registerDecorator({
      name: 'hasNoOverlappingRanges',
      target: object.constructor,
      propertyName: propertyName,
      constraints: [],
      options: validationOptions,
      validator: {
        validate(currentPropertyValue: string, args: ValidationArguments) {
          const overlappingRangeIndex = getFailedConstraints(args.value);
          return overlappingRangeIndex === -1;
        },

        defaultMessage(args: ValidationArguments) {
          return `Time ranges cannot overlap. The range index is: ${getFailedConstraints(args.value)}`;
        },
      },
    });

export function getFailedConstraints(ranges: ScheduleBlock[] = []) {
  if (size(ranges) < 2) {
    return -1;
  }

  for (let firstRangeIndex = 0; firstRangeIndex < ranges.length - 1; firstRangeIndex++) {
    for (let secondRangeIndex = firstRangeIndex + 1; secondRangeIndex < ranges.length; secondRangeIndex++) {
      const firstRangeStart = get(ranges, `${firstRangeIndex}.start`);
      const firstRangeStop = get(ranges, `${firstRangeIndex}.stop`);
      const secondRangeStart = get(ranges, `${secondRangeIndex}.start`);
      const secondRangeStop = get(ranges, `${secondRangeIndex}.stop`);

      if (!firstRangeStart || !firstRangeStop || !secondRangeStart || !secondRangeStop) {
        return -1;
      }

      if (
        (firstRangeStart <= secondRangeStart && secondRangeStart < firstRangeStop) ||
        (firstRangeStart >= secondRangeStart && firstRangeStart < secondRangeStop)
      ) {
        return secondRangeIndex;
      }
    }
  }

  return -1;
}
